import clsx from 'clsx';
import { FC, memo } from 'react';

import styles from './progress-bar.module.scss';
import { IProgressBarProps } from './types';

export const ProgressBar: FC<IProgressBarProps> = memo(
  ({ step, className = '', handleProgressBarFirstStep, handleProgressBarSecondStep, ...rest }) => {
    return (
      <div className={clsx(styles.container, className)} {...rest}>
        <div
          className={clsx(styles.step, styles.step_active)}
          onClick={handleProgressBarFirstStep}
        ></div>
        <div
          className={clsx(styles.step, { [styles.step_active]: step === 2 })}
          onClick={handleProgressBarSecondStep}
        ></div>
      </div>
    );
  },
);
